export default "__VITE_ASSET__554874de__"